import React from 'react';

import {Table} from '@components';
import mappings from '@mappings';
import utils from '@utils';

import {Props} from './types';

export const makeColumns = (
  props: Props,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setIsPaging: React.Dispatch<React.SetStateAction<boolean>>,
  loading: boolean
) => [
  {
    Header: () => {
      return (
        <Table.Sort
          value="名前"
          accessor="lastKana"
          updateCurrent={async (nextSort: string, current: number) => {
            setLoading(true);
            setIsPaging(true);

            await props.actions.users.updateCurrentUsers({
              page: current,
              sort: nextSort,
              teamId: props.me.teamId,
              email: props.users.search.email,
              prefecture: props.users.search.prefecture,
              name: props.users.search.name,
              organization: props.users.search.organization,
              position: props.users.search.position,
            });

            setLoading(false);
            setIsPaging(false);
          }}
          current={props.users.pagination.current}
          currentSort={props.users.pagination.sort}
        />
      );
    },
    accessor: 'lastKana',
    width: 160,
    Cell: ({cell}: {cell: any; column: any}) => {
      const detail = cell.row.original;

      return (
        <Table.Link
          to={`/users/detail/${detail.id}`}
          value={`${detail.lastName} ${detail.firstName}`}
          detail={detail}
        />
      );
    },
  },

  {
    Header: '地域',
    accessor: 'prefecture',
    width: 80,
    Cell: ({cell}: {cell: any; column: any}) => {
      return utils.mappings.getLabel(mappings.prefectures, cell.value);
    },
  },

  {
    Header: 'メールアドレス',
    accessor: 'email',
    width: 300,
    Cell: ({cell}: {cell: any; column: any}) => {
      return cell.value || '-';
    },
  },
  {
    Header: '携帯番号',
    width: 160,
    accessor: 'phoneNumber',
    Cell: ({cell}: {cell: any; column: any}) => {
      return cell.value || '-';
    },
  },
  {
    Header: '権限',
    accessor: 'authLevel',
    width: 180,
    Cell: ({cell}: {cell: any; column: any}) => {
      return utils.mappings.getLabel(mappings.authorities, cell.value);
    },
  },
  {
    Header: '所属組織',
    accessor: 'organization',
    width: 200,
    Cell: ({cell}: {cell: any; column: any}) => {
      return cell.value ? cell.value : '-';
    },
  },
  {
    Header: '役職',
    accessor: 'position',
    width: 200,
    Cell: ({cell}: {cell: any; column: any}) => {
      return cell.value ? cell.value : '-';
    },
  },
  {
    Header: 'メール配信エラー',
    accessor: 'isEmailBounced',
    width: 200,
    Cell: ({cell}: {cell: any; column: any}) => {
      return cell.value ? (
        <span className="c__error_text">メール配信エラー</span>
      ) : (
        <span>-</span>
      );
    },
  },
  {
    Header: () => {
      return (
        <Table.Sort
          value="登録日時"
          accessor="createdAt"
          updateCurrent={async (nextSort: string, current: number) => {
            setLoading(true);
            setIsPaging(true);

            await props.actions.users.updateCurrentUsers({
              page: current,
              sort: nextSort,
              teamId: props.me.teamId,
              email: props.users.search.email,
              name: props.users.search.name,
              prefecture: props.users.search.prefecture,
            });

            setLoading(false);
            setIsPaging(false);
          }}
          disabled={loading}
          current={props.users.pagination.current}
          currentSort={props.users.pagination.sort}
        />
      );
    },
    width: 180,
    accessor: 'createdAt',
    Cell: ({cell}: {cell: any; column: any}) => {
      return utils.date.format(cell.value, 'YYYY/MM/DD HH:mm:ss');
    },
  },
];
